<mat-icon svgIcon={{name}}></mat-icon>